import { Tag, TagLabel, TagLeftIcon, TagProps } from "@chakra-ui/react";
import { RiLightbulbLine } from "react-icons/ri";

export function TipTag(tagProps: TagProps) {
  return (
    <Tag
      size="sm"
      variant="solid"
      colorScheme="purple"
      alignSelf="flex-start"
      flex="none"
      {...tagProps}
    >
      <TagLeftIcon as={RiLightbulbLine} mr={1} />
      <TagLabel>Tip</TagLabel>
    </Tag>
  );
}
